module.exports = __webpack_public_path__ + "img/selected4-min.9c8268e0.png";